import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectCurrentContextFunctionSelector = createFeatureSelector<number>('currentContextFunction');

export const selectCurrentContextFunction = createSelector(
  selectCurrentContextFunctionSelector,
  (state: number) => state,
);
